import { useGetAccountQuery } from "../../../../services/generated";
import { camelizeHyphenCaseKeys } from "@utils/helpers";
import { Account } from "app/javascript/src/types";

const useGetAccount = (slug: string) => {
  const { data, error, isLoading, isFetching, refetch } = useGetAccountQuery({
    slug,
  });
  let account: Account | null = null;

  if (data?.data) {
    account = camelizeHyphenCaseKeys(data.data);
  }

  return { data: account, error, isLoading, isFetching, refetch };
};

export default useGetAccount;
